// extracted by mini-css-extract-plugin
export default {"individualList":"Lists_individualList__u14BT","buttonList":"Lists_buttonList__qwZhf","listImg":"Lists_listImg__84Qyq"};